import type { Router } from '@subaio/utils'

export const getLocation = () => document.location.href

export const getCurrentPage = (router: Router) => router.match(getLocation())
